<template>
  <main class="wrapper-content">
    <template v-if="!isLoading">
      <LmFormHeader :title="$t('Includes')" :name="form.name" />
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" :tab="$t('Main')">
          <b-card class="border">
            <b-row>
              <LmTextInput
                ref="nameInput"
                class="col-12 col-md-6"
                :label="$t('Name')"
                v-model="$v.form.name.$model"
                :v="v('form.name')"
              />

              <LmTextArea
                class="col-12 col-md-6"
                :label="$t('Description')"
                v-model="form.description"
              />
            </b-row>
          </b-card>
        </a-tab-pane>
      </a-tabs>

      <div :class="isOnModal ? 'flex items-center gap-1' : 'buttons'">
        <LmButton
          v-if="isOnModal"
          buttonClass="btn-secondary"
          :value="$t('close')"
          @click="onClose"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-else
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click="onGoBack"
          :isProcessing="isProcessing"
        />

        <LmButton
          buttonClass="btn-primary"
          :value="$t('save')"
          @click="onSubmit"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && !form.deleted"
          buttonClass="btn-danger"
          :value="$t('delete')"
          @click="onDeleteConfirmation"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && form.deleted"
          value="Reactivar"
          buttonClass="btn-success"
          @click="onReactivateConfirmation"
          :isProcessing="isProcessing"
        />

      </div>
    </template>
    <b-row v-else>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col md="12" class="my-4">
        <div>
          <div class="d-flex flex-wrap mb-3" style="gap: 1rem">
            <span
              class="p-2 border rounded-lg d-flex align-items-center justify-content-between"
              style="gap: 1rem"
              v-for="(item, index) in 4"
              :key="index"
            >
              <b-skeleton type="avatar"></b-skeleton>
              <b-skeleton width="100px"></b-skeleton>
            </span>
          </div>
          <b-skeleton type="button" width="150px"></b-skeleton>
        </div>
      </b-col>
    </b-row>
  </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmDatePicker from '@/components/form/elements/LmDatePicker'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmTextInput from '../../components/form/elements/LmTextInput.vue'
import LmEditor from '@/components/form/elements/lmEditor'
import LmTextArea from '../../components/form/elements/LmTextArea.vue'
import LmNumberInputV2 from '@/components/form/elements/LmNumberInputV2.vue'

// Mixins
import lmStandardFormHelperMixin from '@/mixins/lmStandardFormHelperMixin'

// Utils
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [lmStandardFormHelperMixin],
  components: {
    LmDatePicker,
    LmTextInput,
    LmTextArea,
    LmEditor,
    LmTreeSelect,
    LmNumberInputV2,
    LmButton
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    isOnModal: {
      type: Boolean,
      default: false
    },
    dailyActivitiesFrontendRoute: {
      type: String
    },
    programDetailFrontendRoute: {
      type: String
    },
    frontendRouteToRedirectAfterCreated: {
      type: String
    },
    passengerActivitiesEndpoint: {
      type: String
    },
    serviceEndpoint: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      form: {
        name: '',
        deleted: false,
        description: ''
      },
      isProcessing: true
    }
  },
  validations: {
    form: {
      name: { required }
    }
  }
}
</script>
